export const API_BASE_URL: string =
    window.API_BASE_URL || 'https://dailydashboard-dev-func-6gnjeaulvo7ku.azurewebsites.net/api';
